import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderDiscountEntity } from '../../domain/entities/OrderDiscountEntity'
import type { OrderDiscountAdminDto } from '@/backend/market'

export class OrderDiscountModel extends OrderDiscountEntity {
  constructor(dataDto: OrderDiscountAdminDto) {
    super()
    mapEntityProperties<OrderDiscountEntity>(this, dataDto)
  }
}
